import React from 'react';
import { Paper, Box } from '@mui/material';
import { useSocket } from "../../SocketContext";
import Actions from './Actions';

import { generateUniqueId } from '../../utils/commonUtils';
import MarkdownContent from './StyledMarkdown';

const SystemMessage = ({ dataItem }) => {

    return (
        <Box sx={{
            display: 'flex', alignItems: 'flex-start',
            // padding: 1,
            position: 'relative',
            marginBottom: 4
        }}>
            <Box
                sx={{
                    paddingX: 2,
                    borderRadius: "0px 0px 8px 8px",
                    flexGrow: 1,
                    backgroundColor: 'grey.A100',
                    // color: 'secondary',
                    width: '100%',
                    position: 'relative',
                    '&:hover .actions': { opacity: 1 },
                    border: 1,
                    borderColor: 'divider',
                    // boxShadow: '0px 1px 3px rgba(0,0,0,0.2)',
                    // overflowX: 'auto',
                }}
            >
                <Box
                    sx={{
                        overflow: 'auto',
                        wordWrap: 'break-word',
                    }}
                >
                    <MarkdownContent data={dataItem.response_data} />
                </Box>
                <Actions dataItem={dataItem} />
            </Box>
        </Box>
    );
};

export default SystemMessage;
